<template>
  <div class="unassigned-store">
    <!-- 待分配门店 -->
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.storesToBeAllocated')">
      <div class="right-header">
        <img class="icon-img" src="@/assets/images/map_time.png" alt="" @click="toPage('/unassignedStore/unassignedRecord')">
      </div>
    </NavHeaderBar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="No more data" @load="onLoad" :immediate-check="false">
        <div class="activity-item" v-for="(item, index) in list" :key="index">
          <div class="header-info">
            <span class="item-time">{{ $t('shared.visitTime') }}: {{ item.visitTime }}</span>
            <span class="item-name">{{ item.createUserName }}</span>
          </div>
          <div class="item-body">
            <div class="store-name">{{ item.customerName }}</div>
            <div class="listing-item">
              <van-icon v-if="item.isListing === 1" name="checked" color="#307bff" class="status-icon" />
              <van-icon v-else name="clear" color="#c4200b" class="status-icon" />
              <span class="status-txt van-ellipsis">{{ item.productList.join(',') }}</span>
            </div>
            <div class="listing-item">
              <van-icon v-if="item.isEvent === 1" name="checked" color="#307bff" class="status-icon" />
              <van-icon v-else name="clear" color="#c4200b" class="status-icon" />
              <span class="status-txt van-ellipsis">{{ $t('shared.eventInvitations') }}</span>
            </div>
          </div>
          <div class="oper-btn">
            <van-button plain type="primary" color="#555555" size="small" @click="toPage(`/storeExpansion/visitSellInDetail?visitId=${item.visitId}&pageType=unassignedStore`)">{{ $t('button.visitInfo') }}</van-button>
            <van-button type="info" color="#307bff" size="small" @click="toPage(`/unassignedStore/transferAssign?assignId=${item.id}`)">{{ $t('button.assign') }}</van-button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { customerAllotListPageApi } from '@/api/unassignedStore'
export default {
  data () {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      page: 1,
      pageSize: 10
    }
  },
  activated () {
    this.page = 1
    // Initial load
    this.onLoad()
  },
  methods: {
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    onLoad () {
      // Mock API call
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const data = {
        page: this.page,
        limit: 10
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      customerAllotListPageApi(data).then(res => {
        Toast.clear()
        if (this.page === 1) {
          this.list = res.data.list
        } else {
          this.list = [...this.list, ...res.data.list]
        }
        this.loading = false
        this.page++
        if (this.list.length >= Number(res.data.totalRow)) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    toPage (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.unassigned-store {
  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .activity-item {
    background-color: #fff;
    margin-bottom: 1px; // Divider effect
    border-bottom: 1px solid #f0f0f0;

    .header-info {
      display: flex;
      justify-content: space-between;
      padding: 12px 10px 10px 10px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 13px;
      .item-time {
        color: #7f7f7f;
      }
      .item-name {
        color: #307bff;
      }
    }

    .item-body {
      padding: 10px;
      font-size: 13px;
      .store-name {
        color: #333;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .listing-item {
        display: flex;
        align-items: center;
        color: #555;
        margin-bottom: 6px;
        .status-icon {
          margin-right: 6px;
        }
        .status-txt {
          flex: 1;
        }
      }
    }
    .oper-btn {
      display: flex;
      justify-content: flex-end;
      padding: 10px;
      padding-top: 0;
      /deep/.van-button {
        height: 30px;
        width: 76px;
        border-radius: 5px;
        margin-left: 10px;
      }
    }
  }
}
</style>
